<template>
<layout-content>
  <template #toolbar>
    <div style="display:flex;align-items:center;gap:1rem;margin-top:-7px;">
      <el-steps :active="step" align-center size="mini">
        <el-step
          v-for="component in components"
          :key="component.name"
          :title="component.label"
        />
      </el-steps>

      <el-button :disabled="step === 0" type="primary" plain icon="el-icon-arrow-left" size="small" @click="onStepBtnClick(-1)">上一步</el-button>
      <el-button :disabled="step === (components.length - 1)" type="primary" plain size="small" @click="onStepBtnClick(1)">下一步<i class="el-icon-arrow-right el-icon--right"></i></el-button>
      <el-button type="primary" size="small" icon="el-icon-search" :style="{
        visibility: step > 1 ? 'visible' : 'hidden'
      }" @click="onResetQueryBtnClick">重设选择条件</el-button>
    </div>
  </template>

  <template #body>
    <data-wrapper>
      <Component
        ref="step-component"
        :is="components[step].name"
        :condition="condition"
        :data-types="dataTypes"
        :audit-types="auditTypes"
        :sites="filterSites"
        :site-factor-map="siteFactorMap"
        :step-data="stepData"
        :source-type="1"
        style="flex:1 0 100%;min-height:0;padding-top:1.5rem;"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../../model/DeviceCategoryConfig'
import loader from '../../../../../utils/loader'

import LayoutContent from '../../../../../components/Layout/Content'

const components = Object.values(loader.getByFileName(require.context('./../../01PM/01Run/steps', true, /\.(vue)$/)))

export default {
  name: 'PMFAnalysisVOCs',
  routeInfo: {
    label: '源解析分析',
    icon: 'fa fa-users'
  },
  extends: BaseSiteFactorData,
  components: components.reduce((map, component) => {
    map[component.name] = component
    return map
  }, {
    LayoutContent
  }),
  data: () => ({
    step: 0,
    condition: {
      id: null,
      beginTime: null,
      endTime: null,
      auditType: 0,
      dataType: 0,
      siteId: null,
      factorIds: [],
      runCount: 20,
      sourceCount: 5
    },
    stepData: components.reduce((map, component) => {
      map[component.stepDataKey] = null
      return map
    }, {})
  }),
  computed: {
    components: () => components,
    siteDeviceCategoryConfig: () => [
      new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, true)
    ],
    auditTypes: () => [{
      value: 1,
      label: '原始数据'
    }, {
      value: 2,
      label: '审核数据'
    }, {
      value: 3,
      label: '混合'
    }],
    dataTypes: () => [{
      value: 60,
      label: '小时均值',
      formatter: 'YYYY年MM月DD日HH时'
    }, {
      value: 1440,
      label: '日均值',
      formatter: 'YYYY年MM月DD日'
    }]
  },
  methods: {
    onStepBtnClick (step) {
      const nextStep = this.step + step

      if (this.components[nextStep]) {
        if (step > 0) {
          this.$refs['step-component'].nextStep().then(data => {
            if (data) {
              const {stepData, components} = this
              stepData[components[this.step].stepDataKey] = data
              const componentsLen = components.length

              for (let i = nextStep; i < componentsLen; i++) {
                stepData[components[i].stepDataKey] = null
              }
            }

            this.step = nextStep
          }).catch(() => {})
        } else {
          this.step = nextStep
        }
      }
    },
    onResetQueryBtnClick () {
      this.onStepBtnClick(-this.step)
      this.setSiteIds()

      const {stepData} = this

      for (let key in stepData) {
        stepData[key] = null
      }
    },
    setSiteIds () {
      let {filterSites} = this

      if (filterSites.length === 0) {
        return
      }

      this.$nextTick(() => {
        this.$refs['step-component'].reset()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-steps {
  width: 600px;
  background-color: transparent;

  /deep/ {
    .el-step__main {
      white-space: nowrap;
    }
  }
}

.el-button {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/02VOCs/01Run/index.vue